module.exports = {
          srcSet: "/_next/static/images/google_logo-25-ddabd9be36c8e22cd3166433497d193e.png"+" 25w",
          images:[ {path: "/_next/static/images/google_logo-25-ddabd9be36c8e22cd3166433497d193e.png",width: 25,height: 25}],
          src: "/_next/static/images/google_logo-25-ddabd9be36c8e22cd3166433497d193e.png",
          toString:function(){return "/_next/static/images/google_logo-25-ddabd9be36c8e22cd3166433497d193e.png"},
          placeholder: undefined,
          width: 25,
          height: 25
      }